import { Factory } from './factory';
import { Video } from '../video';
import { Position } from '../position';
import { ApplicationStateService } from '../../services/application-state.service';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class VideoFactory implements Factory<Video> {

    constructor(private applicationStateService: ApplicationStateService) {

    }

    buildFromFactory(): Video {
        return undefined;
    }

    buildFromObject(jsonObject: any): Video {
        const video = new Video();
        video.id = jsonObject.id;
        video.pageId = jsonObject.pageId;
        const position = new Position();
        position.x = +jsonObject.position.x;
        position.y = +jsonObject.position.y;
        position.w = +jsonObject.position.w;
        position.h = +jsonObject.position.h;
        video.position = position;
        video.url = jsonObject.url;
        video.content = jsonObject.content;
        video.bypassCheck = this.applicationStateService.bookConfig.bookPermissions.bookVideo.view;

        return video;
    }

}
